import getReportHistoryData from "./getReportHistoryData";
export const getReportHistoryDataPromise = getReportHistoryData;